import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Observable, Subject } from 'rxjs';
// import { GetEmployeeWagesList, GetEmployeeWagesLogsList, payrateGridBO } from './employee.model';
import { map } from 'rxjs/operators';
import { GetEmployeeWagesLogsList } from '../employee.model';


@Injectable({
  providedIn: 'root'
})
export class EmployeeWagesLogsService extends Subject<DataStateChangeEventArgs> {

  constructor(private http: HttpClient) {
    super();
  }

 
  public executewagesLogs(state: GetEmployeeWagesLogsList): void {
    this.getListEmployeewagesLogs(state).subscribe(x => super.next(x));
  }

  getListEmployeewagesLogs(state?: GetEmployeeWagesLogsList): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/EmployeeyearlySummaries/GetEmpWagesLogsList", state)
      .pipe(map(
        (response: any) => (<any>{
          result: response['result'],
          count: response['count']
        }))


      )
  }
}
